module.exports = __webpack_public_path__ + "img/section10_ru.b9b208b.png";